import './Link.scss';
import '../Button/Button.scss';

type LinkProps = {
  children: React.JSX.Element | string;
  href: string;
  displayBlock?: boolean;
  className?: string;
  targetSelf?: boolean;
};

function Link({
  children,
  href,
  displayBlock,
  className,
  targetSelf,
}: LinkProps): React.JSX.Element {
  return displayBlock ? (
    <div className='link__wrapper'>
      <a
        className={`link ${className ? className : ''}`}
        href={href}
        target={targetSelf ? '_self' : '_blank'}
        rel='noreferrer'
      >
        {children}
      </a>
    </div>
  ) : (
    <a
      className={`link ${className ? className : ''}`}
      href={href}
      target='_blank'
      rel='noreferrer'
    >
      {children}
    </a>
  );
}

export default Link;
